import { useState, useEffect } from "react";
import { useCreateTemplatesMessage } from "./useFetchTemplatesMessage";
import { useFormikMessageTemplate } from "./useFormikMessageTemplate";
import { errorLabels } from "../../../../utils/helpers";
import { ErrorMessage } from "../../../../utils/toastify";
import { useFetchDetailTemplatesMessage } from "./useFetchTemplatesMessage";
import { useUpdateTemplatesMessage } from "./useFetchTemplatesMessage";
import { useNavigate } from "react-router-dom";
export const useTemplatesMessage = (uuid_message_template) => {
  const navigate = useNavigate();
  const { mutateAsync: createTemplates, isPending: isLoadingCreate } =
    useCreateTemplatesMessage();
  const { mutateAsync: updateTemplates, isPending: isLoadingUpdate } = useUpdateTemplatesMessage();

  const { data, isLoading, isFetched } = useFetchDetailTemplatesMessage(
    uuid_message_template,
  );

  const [isUpdate, setIsUpdate] = useState(false);
  const [reset, setReset] = useState(false);
  const formik = useFormikMessageTemplate({
    onSubmit: async (values) => {
      if (uuid_message_template) {
        await updateTemplates(values);
      } else {
        await createTemplates(values);
      }
    },
  });

  useEffect(() => {
    if (!isFetched) return;
    if (!data || data?.uuid_messages_templates !== uuid_message_template) {
      navigate("/rcs/MessageTemplates", { replace: true });
    }
  }, [data, uuid_message_template]);

  useEffect(() => {
    if (uuid_message_template && data && isFetched) {
      setIsUpdate(true);
      formik.setValues({
        ...data,
      });
    } else if (!uuid_message_template) {
      setIsUpdate(false);
    }
  }, [uuid_message_template, data, isFetched]);

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return {
    formik,
    isLoading: isLoadingCreate || isLoadingUpdate,
    data,
    reset,
    _validate,
    handleReset,
    isLoadingDetail: isLoading,
    isUpdate,
  };
};
